<template>
    <div class="news-detail-content">
        <h3>{{infos.title}}</h3>
        <div v-html="infos.content"></div>
   </div>
</template>

<script>
export default {
    name:'newsContent',
    data(){
        return{
            infos: '',
            newId:''
        } 
    },
    mounted(){
        this.baseUrl = window.baseUrl;
        this.config = window.config;
        this.newId = this.$route.params.new_id;
        this.getDetail();
    },
    methods:{
        getDetail: function(){
            var that = this;
            that.$http.post(that.baseUrl+that.config.newsDetails+'?new_id='+that.newId).then(function(ev){
                // console.log(ev);
                if(ev.data.code == 100){
                    that.details = ev.data.data;
                    that.infos = ev.data.data.info;
                    
                    that.down = ev.data.data.down;
                    that.up = ev.data.data.up;
                    that.type = ev.data.data.info.type;
                    
                }
                for(var i = 0;i<that.typeList.length;i++){
                    if(that.type == that.typeList[i].type){
                        that.toLinktext = that.typeList[i].text;
                        that.toLinkroute = that.typeList[i].routeTo;
                    }
                }
            }).catch(function(error){
                console.log(error)
            })
        },
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/newsContent.vue